/**
 * CategoryDetailsData contains the results of the getCategoryDetailsData() API call.
 *
 * This info could be considered part of a Category model, but the data is calculated on-demand and
 * isn't part of the server-side CategoryBean that our Category model reflects.  Instead, we store
 * these stats in this model, and then use calls on the Category model to create/update this model & attach
 * it to the Category.
 *
 * CategoryDetailsData cannot be written to the server; it is a fetch-only model.
 *
 * @class
 */
import Base from '@netx/core/lib/netx-model';

export default class CategoryDetailsData extends Base {
	/**
	 * @type {Netx.Rpc}
	 * @private
	 */
	get rpc() {
		return true;
	}

	/**
	 * The unique ID for this model
	 * @type {string}
	 */
	get idAttribute() {
		return 'categoryId';
	}

	/** @type {boolean} */
	get xhrTrackProgress() {
		return true;
	}

	/**
	 * @property {object}  defaults                   - The default attribute values
	 * @property {string}  defaults.byteCount         - Total bytes of all assets in the category (recursive)
	 * @property {string}  defaults.fileCount         - Total number of files in the category (recursive)
	 * @property {string}  defaults.subcategoryCount  - Total number of subcategories in the category (recursive)
	 */
	get defaults() {
		return {
			byteCount: '',
			fileCount: 0,
			subCategoryCount: 0,
		};
	}

	/**
	 * RPC methods:
	 * @rpcs
	 */
	get methods() {
		return {
			/** @method */
			read: ['getCategoryDetailsData', 'categoryId'],
		};
	}

	/** @type {string} */
	static get __name__() {
		return 'CategoryDetailsData';
	}
}
